module.exports = __webpack_public_path__ + "static/FoodBank-902e5b8e3e4bdf95d770bcd7fff22c52.png";